"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTabs = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../utils/classFunctions");
const Link_1 = require("./Link");
require("./index.scss");
const className = 'page-tabs';
const PageTabs = (props) => {
    const { isRouteMatch = () => false, modificators, routeItems, children, } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
    const tabs = routeItems ? routeItems.map((route) => (react_1.default.createElement(Link_1.PageTabsLink, { key: `PageTabBarLink:${route.routeKey}`, navigationClassName: className, isRouteMatch: isRouteMatch, ...route }))) : null;
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: `${className}__header` },
            react_1.default.createElement("div", { className: `${className}__nav` }, tabs)),
        react_1.default.createElement("div", { className: `${className}__content` }, children)));
};
exports.PageTabs = PageTabs;
//# sourceMappingURL=index.js.map